import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { nationActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { nation } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setNationList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentNation = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionNation = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const nationReducer = createReducer(nation, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setNationList,
  [actions.CURRENT]: setCurrentNation,
  [actions.CUD]: actionNation,
});
